export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  dynamicParam: '/:mode/:contractType?/:contractId?',
} as TCommon.RouteConfig
